import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchRollbackReport } from "@custom/rtk-apis/report/RollbackDetail";
import { ReportState } from "@custom/Utils/constants/interfaces";

export const initialState: ReportState = {
  status: "",
  result: null,
  msg: "",
  loading: false,
  error: null,
};

// Create the slice
const getRollbackReportSlice = createSlice({
  name: "getReportIdSlice",
  initialState,
  reducers: {
    revertStatus: (state) => {
      state.status = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRollbackReport.pending, (state) => {
        console.log("Pending");
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRollbackReport.fulfilled, (state, action: PayloadAction<any>) => {
        console.log("Fulfilled", action.payload);
        state.loading = false;
        state.status = action.payload.status;
        state.result = action.payload.result;
        state.msg = action.payload.msg;
      })
      .addCase(fetchRollbackReport.rejected, (state, action: PayloadAction<any>) => {
        console.log("Rejected");
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default getRollbackReportSlice.reducer;
export const { revertStatus } = getRollbackReportSlice.actions;
